module.exports = __webpack_public_path__ + "static/media/301.613dcd36.png";